import { IdiomaCalendario } from '../../../domain/IdiomaCalendatio';
import { IdiomaService } from '../../../providers/idioma/idioma.service';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ServiciosWebServiceProvider } from '../../../providers/web-service-service/servicios-web-service';
import { AuthenticationService } from '../../../providers/authentication/authentication.service';
import { EntityManagerProvider } from '../../../providers/entity-manager-provider/entity-manager-provider';
import { Message, MenuItem } from 'primeng/primeng';
import { ActivatedRoute, Router } from '@angular/router';
import * as allSettled from 'promise-all-settled';
import { ConfirmationService } from 'primeng/api';
import { Contenido } from '../../../domain/Contenido';
import { BreadcrumbService } from '../../../breadcrumb.service';
import { Idioma } from '../../../domain/Idioma';
import {TranslateService} from 'ng2-translate';
import { CropperSettings } from 'ngx-img-cropper';
import { Constantes } from '../../../domain/constantes';
import { PermisosService, Permisos } from '../../../providers/authentication/permisos.service';
import { Predicate } from 'breeze-client';
import { AppComponent } from '../../../app.component';
import { EspacioFormulario } from '../../../domain/EspacioFormulario';
import { PlanoComponent, SeccionPlano } from 'interiores-mapa';
import { NotificacionPlano } from 'interiores-mapa/dist/notificacionPlano';

import { SeccionFormulario } from '../../../domain/SeccionFormulario';
import { AlaFormulario } from '../../../domain/AlaFormulario';
import { NodoFormulario } from '../../../domain/NodoFormulario';
import { AvisoCiudadanoFormulario } from '../../../domain/AvisoCiudadanoFormulario';

const FILTRO_INI = JSON.stringify({
	where: {
		Titulo: '',
		estado: 4,
		// expirado: new Predicate('FechaAlta', '>=', '1900-01-01'),
		Desde: '',
		Hasta: '',
		ElementoAsignado: '',
		IdAlternativo: '',
		Tipologia: ''
	},
	order: 'Titulo DESC',
	top: 10,
	page: 0,
	total: 0
});
// Necesario para mostrar mensajes con esta plantilla
@Component({
	templateUrl: './nuevo.mensaje.component.html',
	styleUrls: ['./nuevo.mensaje.component.scss'],
	providers: [ConfirmationService]
	// , declarations: [ImageCropperComponent]
})

export class NuevoMensajeComponent implements OnInit, OnDestroy {
	@ViewChild('dt_no_asignados') dt_no_asignados;
	@ViewChild('pg_no_asignados') pg_no_asignados;

	spinner: HTMLElement;
	blockUI: HTMLElement;
	blockUIPlano: HTMLElement;

	public msgs= [];
	public msgPosicionar = [];
	public msgPushNoProvisionado = [];
	public msgAvisoContenido = [];
	public msgFoto: Message[] = [];

	public esNuevo = false;
	public esEdicion = false;
	public esCopia = false;
	public esPreview = false;

	public espacioSeleccionado: EspacioFormulario = new EspacioFormulario();
	public alaSeleccionada;
	public nodoSeleccionado;

	public listaEntidades = [];
	public listaNodos: NodoFormulario[] = [];
	public listaAlas: AlaFormulario[] = [];
	public listaSecciones: SeccionFormulario[] = [];

	// columnas tabla
	public colSecciones = [];
	public colsAsignados: any[] = [];
	public colsTodos: any[] = [];


/* AVISO */
	public AvisoSeleccionado: AvisoCiudadanoFormulario = new AvisoCiudadanoFormulario();
	public criteriosEnvio = []; // Siempre true
// ---

// Validacion
	public isValid = true;
	public tituloError = false;
	public contenidoError = false;
	public fAltaError = false;
	public fBajaError = false;
	public accionError = false;
// ---

/* FOTO */
	@ViewChild('cropper') cropper;
	imagenSeleccionada: any;
	cropperSettings: CropperSettings;
	imageCropperVisible = false;
	data: any;
	// cropper: ImageCropperComponent;
	permisos: Permisos;
// --

/* IDIOMA */
	idiomas;
	idiomaSeleccionado: Idioma;
	idiomaDefecto: Idioma;
	idiomaCalendario: IdiomaCalendario;
// ---

/* Opciones Ennvio */
	listaOpcionesEnvio = [
		{ index: 4, Nombre: this.translate.instant('Mensajes.puntualporespacio')},
		{ index: 0, Nombre: this.translate.instant('Mensajes.puntualporseccion')},
		{ index: 1, Nombre: this.translate.instant('Mensajes.programadoporespacio')},
		{ index: 2, Nombre: this.translate.instant('Mensajes.programadoporseccion')},
		{ index: 3, Nombre: this.translate.instant('Mensajes.programadoporubicacion')}
	];
	opcionEnvioSeleccionada = this.listaOpcionesEnvio[0];
// ---

/* MAPA */
	@ViewChild('planoPosicion') planoPosicion: PlanoComponent;
	pathPlano: String;
	zoomLevels: Number[];
	zoomCenterCoords: Number[];

	sectionsPlano: Array<SeccionPlano>;
	mapSectionsPlano: Map<String, SeccionPlano>;

	avisosPlano: Array<NotificacionPlano>;
	mapAvisosPlano: Map<String, NotificacionPlano>;

	seccionDefecto: SeccionFormulario;
	public seccionClicada: SeccionFormulario;

	public offset_x_icono_contenido = -30;
	public offset_y_icono_contenido = -30;

// ---


// Contenido asociado
	contenidosTodos: Contenido[] = [];
	contenidosFiltrados: Contenido[] = [];
	public contenidoSeleccionado: Contenido[] = [];
	public displayDialog: boolean = false;
	public filtro = JSON.parse(FILTRO_INI);

	public tipologiasContenido = [		{
		tipo: 'TODOS',
		value: 'TODOS',
		clases: [],
		label: 'Todos'
	}];
	public tipologiasContenidoSeleccionada = this.tipologiasContenido[0];

	triggerPageChange: boolean = true;
	public ContenidoEstado = [
		{
			tipo: 'PROXIMOACT',
			value: 5,
			clases: [],
			label: 'Contenidos.estadoProximoAct'
		},
		{
			tipo: 'ACTIVO',
			value: 3,
			clases: ['ui-message', 'ui-corner-all'],
			label: 'Contenidos.estadoActivo'
		},
		{
			tipo: 'PROXIMO',
			value: 1,
			clases: ['ui-message', 'ui-messages-warning', 'ui-corner-all'],
			label: 'Contenidos.estadoProximo'
		},
		{
			tipo: 'EXPIRADO',
			value: 0,
			clases: ['ui-message', 'ui-messages-error', 'ui-corner-all'],
			label: 'Contenidos.estadoExpirado'
		}
	];
	public ContenidoEstadoMod = this.ContenidoEstado[0];
	idEditar: any;
// ---

// PESTAÑAS
	public tabMenuItems: MenuItem[];
	public activeItem: MenuItem;

	hideMensaje = false;
	hideTipo = true;
	hideEstadisticas= true;
// ---
	constructor(
		private appComponent: AppComponent,
		public sws: ServiciosWebServiceProvider,
		public authService: AuthenticationService,
		private entityManager: EntityManagerProvider,
		private breadcrumbService: BreadcrumbService,
		private confirmationService: ConfirmationService,
		private idiomaService: IdiomaService,
		private translate: TranslateService,
		private permisosService: PermisosService,
		private router: Router,
		private route: ActivatedRoute

	) {
		this.spinner = document.getElementsByClassName('spinner-container')[0] as HTMLElement;
		this.spinner.style.display = 'inherit';

		this.blockUI = document.getElementsByClassName('blockUI')[0] as HTMLElement;
		this.blockUI.style.display = 'none';

		this.blockUIPlano = document.getElementsByClassName('blockPosicionarNotificacion')[0] as HTMLElement;
		if (this.blockUIPlano) {
			this.blockUIPlano.style.display = 'inherit';
		}

		this.breadcrumbService.setItems([
			{ label: this.translate.instant('Mensajes.mensajes'), routerLink: ['/mensajes'] },
			{ label: this.translate.instant('Mensajes.detalle') }
		]);

		console.log('*** MensajesComponent ***');
		this.colsAsignados = [
			{ field: 'Drag', header: '' },
			{ field: 'Imagen', header: this.translate.instant('RutasSugeridas.imagen') },
			{ field: 'Titulo', header: this.translate.instant('RutasSugeridas.nombre') },
			{ field: 'Descripcion', header: this.translate.instant('RutasSugeridas.descripcion') },
			{ field: 'Seccion', header: this.translate.instant('RutasSugeridas.Seccion')  },
			{ field: 'MostrarEdicion', header: '' }
		];

		this.colsTodos = [
			{ field: 'Imagen', fieldSort: '', header: this.translate.instant('Contenidos.imagen')}, // clases: ['th-tipo-corto1']},
			{ field: 'Titulo', fieldSort: 'Titulo', header: this.translate.instant('Contenidos.titulo')}, // clases: ['th-tipo-normal'] },
			{ field: 'expirado', fieldSort: 'expirado', header: this.translate.instant('Contenidos.estado')}, // clases: ['th-tipo-corto2'] },
			{ field: 'IdAlternativo', fieldSort: 'IdAlternativo', header: this.translate.instant('Contenidos.idAlternativo')}, // clases: ['th-tipo-medio'] },
			{ field: 'TIPOLOGIA_CONTENIDO', fieldSort: 'Tipologia', header: this.translate.instant('Contenidos.tipologia')}, // clases: ['th-tipo-medio'] },
			{ field: 'MostrarEdicion', fieldSort: '', header: '' }
		];


		this.data = {};

		this.colSecciones = [
			{ field: 'Nombre', header: this.translate.instant('Mensajes.nombre') },
			{ field: 'nivelSeccion', header: this.translate.instant('Mensajes.nivel') }
		];

		this.filtro.where.expirado = new Predicate('FechaAlta', '>=', '1900-01-01');
		this.cropperSettings = new CropperSettings();
		this.cropperSettings.width = 400;
		this.cropperSettings.height = 400;
		this.cropperSettings.croppedWidth = 400;
		this.cropperSettings.croppedHeight = 400;
		this.cropperSettings.canvasWidth = 400;
		this.cropperSettings.canvasHeight = 400;
		this.cropperSettings.noFileInput = true;
		this.cropperSettings.fileType = "image/webp";
		this.cropperSettings.minWithRelativeToResolution = true;

		this.idiomaCalendario = new IdiomaCalendario();
		this.idiomaCalendario.firstDayOfWeek = 1;
		this.idiomaCalendario.dayNames = this.translate.instant('Calendario.dayNames');
		this.idiomaCalendario.dayNamesShort = this.translate.instant('Calendario.dayNamesShort');
		this.idiomaCalendario.dayNamesMin = this.translate.instant('Calendario.dayNamesMin');
		this.idiomaCalendario.monthNames = this.translate.instant('Calendario.monthNames');
		this.idiomaCalendario.monthNamesShort = this.translate.instant('Calendario.monthNamesShort');
		this.idiomaCalendario.today = this.translate.instant('Calendario.today');
		this.idiomaCalendario.clear = this.translate.instant('Calendario.clear');

		this.msgAvisoContenido = [];

		this.msgAvisoContenido.push({severity: 'info', detail: this.translate.instant('Mensajes.avisoasignarcontenido')});

		this.tabMenuItems = [
			{
				label: this.translate.instant('Mensajes.nuevomensaje'),
				icon: 'iticon-tab-editar',
				command: (event: any) => {
					this.tabMensajeSeleccionada();
				}
			},
			{
				label: this.translate.instant('Mensajes.tipodenotificacion'),
				icon: 'iticon-tab-nodo',
				command: (event: any) => {
					this.tabTipoSeleccionada();
				}
			},
			{
				label: this.translate.instant('Mensajes.estadisticas'),
				icon: 'iticon-tab-dashboard',
				command: (event: any) => {
					this.tabWebEstadisticasSeleccionada();
				}
			}
		];

		this.activeItem = this.tabMenuItems[0];


		this.comprobarPermisos();
		this.spinner.style.display = 'none';
	}

	comprobarPermisos() {
		const userId = this.authService.getIdUsuario();
		const that = this;
		return this.permisosService.getPermisosUsuario(userId)
		.then(function(perm: Permisos){
			that.permisos = perm;
		});
	}

// CARGA
	ngOnInit() {
		const that = this;
		window.scroll(0, 0);
		// Mostramos Spinner
		this.spinner.style.display = 'inherit';


		this.route.params
			.subscribe(params => {

				this.idEditar = params['id'];
				const stringValue =  params['es'];

				if(stringValue === 'nuevo'){
					this.esNuevo = true;
					this.esEdicion = false;
					this.esCopia = false;
					this.esPreview = false;
				}
				if(stringValue === 'edicion'){
					this.esNuevo = false;
					this.esEdicion = true;
					this.esCopia = false;
					this.esPreview = false;
				}
				if(stringValue === 'copia'){
					this.esNuevo = false;
					this.esEdicion = false;
					this.esCopia = true;
					this.esPreview = false;
				}
				if(stringValue === 'preview'){
					this.esNuevo = false;
					this.esEdicion = false;
					this.esCopia = false;
					this.esPreview = true;
				}

				// this.esEdicion = esEditable && (this.idEditar === undefined ? false : true) // Es una edicion si recibimos un id editable, sino es nuevo o previsualizacion

			});

		this.listaNodos = [];
		this.listaAlas = [];
		this.listaSecciones = [];

		this.loadSecciones();

		this.entityManager.getIDIOMA()
		.then(function (idiomasENTIDAD: any) {

			that.idiomas = [];
			idiomasENTIDAD.forEach(idioma => {
				if(idioma.Visible === true){
				that.idiomas.push(new Idioma(idioma));
				}
			});

			that.idiomaDefecto = that.idiomaService.getIdiomaDefecto(that.idiomas);
			that.idiomaSeleccionado = that.idiomaDefecto;

		})
		.then(function(){
			// ASIGNADOS
			let value = '';
			let matchMode = '';
			if (that.dt_no_asignados.filters && that.dt_no_asignados.filters.global) {
				value = that.dt_no_asignados.filters.global.value;
				matchMode = that.dt_no_asignados.filters.global.matchMode;
			}

			that.dt_no_asignados.reset();

			if (that.dt_no_asignados.filters && that.dt_no_asignados.filters.global) {
				that.dt_no_asignados.filterGlobal(value, matchMode);
			}

			return true;
		})
		.then(function () {
			return that.permisosService.obtenerTIPOLOGIA_CONTENIDO();
		})
		.then(function (e) {
			that.tipologiasContenido = e;
			return that.comprobarPermisos();
		})
		.then(function () {
			return that.loadMensaje(that.idEditar);
		})
		.then(function () {
			that.spinner.style.display = 'none';
		})
		.catch(function (err) {
			console.log('Error cargarDatos: ' + err);
			that.spinner.style.display = 'none';
		});
	}

	ngOnDestroy(): void {
		this.entityManager.RejectChanges();
	}

	loadSecciones(){
		const that = this;
		const idEspacio = this.authService.getIdEspacio();
		this.entityManager.getEspacioById(idEspacio, 'NIVELS.ALAS.SECCIONS.NODOS')
		.then(function (espacio: any){

			if (espacio !== undefined) {

				that.espacioSeleccionado = new EspacioFormulario(espacio);
				that.listaAlas = [];
				espacio.NIVELS.forEach(nivel => {
					nivel.ALAS.forEach(a => {

						const ala = new AlaFormulario(a);
						that.listaAlas.push(ala);
						that.listaEntidades.push(ala);

						ala.ENTIDAD.SECCIONS.forEach( s => {

							if (s.Nombre !== 'Default') {
								console.log(s)
								s.nivelSeccion = s.ALA.NIVEL.NivelVertical;

								const seccion = new SeccionFormulario().fromENTIDAD(s);
								seccion.nivelSeccion = s.ALA.NIVEL.NivelVertical;
								that.listaSecciones.push(seccion);
								that.listaEntidades.push(seccion);
							}

							s.NODOS.forEach( n => {
								const nodo = new NodoFormulario().fromENTIDAD(n);
								that.listaNodos.push(nodo);
								that.listaEntidades.push(nodo);
							});

						});

						that.seleccionarAlaPresionado(that.listaAlas[0]);

					});
				});
				that.listaSecciones.sort((a, b) => a.Nombre.localeCompare(b.Nombre));
				that.AvisoSeleccionado.secciones = that.listaSecciones;
			}

			return that.entityManager.getEntidadById(espacio.IdEntidad);
		})
		.then(function (entidad: any){

			if (!entidad.EntidadSIC || !entidad.PasswordSIC || !entidad.UrlSIC || !entidad.UserSIC){
				that.msgPushNoProvisionado.push({severity: 'warn', detail: that.translate.instant('Mensajes.pushnoconfigurado')});
			}

		})
		.catch(function (e) {
			that.appComponent.showError(e.message);
			return false;
		});
	}


	loadMensaje(idEditar){
		this.spinner.style.display = 'inherit';
		const that = this;
		const expands = 'SECCIONES.SECCION, CONTENID.FOTOS, FOTO, NODOS.NODO, ESPACIOS.ESPACIO';
		const predicado = new Predicate('Id', '==', idEditar);

		return this.entityManager.getAVISO_CIUDADANO(predicado, expands)
		.then(function (datos: any[]){

			if (!datos){
				that.spinner.style.display = 'none';
				return;
			}

			datos.forEach(mens => {
				try {
					that.AvisoSeleccionado = new AvisoCiudadanoFormulario().fromENTIDAD(mens);

					if (that.esCopia){
						that.AvisoSeleccionado.Contenido = that.AvisoSeleccionado.Contenido + that.translate.instant('Mensajes.copia');
					}

					// Inmediata a Sección o Espacio
					if ( mens.Tipo === 0) {
						if (that.AvisoSeleccionado.secciones.length > 0){
							that.opcionEnvioSeleccionada = that.listaOpcionesEnvio.find( o => o.index === 0); // SECCION
						}
						else{
							that.opcionEnvioSeleccionada = that.listaOpcionesEnvio.find( o => o.index === 4); // ESPACIO

						}
					}

					// Programada a Espacio
					if (that.AvisoSeleccionado.espacios.length > 0 && mens.Tipo === 1) {
						that.opcionEnvioSeleccionada = that.listaOpcionesEnvio.find( o => o.index === 1);
					}
					// Programada a Sección
					if (that.AvisoSeleccionado.secciones.length > 0 && mens.Tipo === 1) {
						that.opcionEnvioSeleccionada = that.listaOpcionesEnvio.find( o => o.index === 2);
					}
					// Programada a Ubicación
					if (that.AvisoSeleccionado.nodos.length > 0 && mens.Tipo === 1) {
						that.opcionEnvioSeleccionada = that.listaOpcionesEnvio.find( o => o.index === 3);
					}
					if (mens.CONTENID) {
						const contenido = new Contenido().fromENTIDAD(mens.CONTENID);
						that.contenidoSeleccionado = [contenido];
					}
				}
				catch (ex) {
					that.appComponent.showError(that.translate.instant('MensajesEmergentes.MENSAJE_ERROR_MENSAJES_CARGAR'));
				}
			});

			that.spinner.style.display = 'none';

		})
		.catch(function (e) {
			console.log(e);
			that.appComponent.showError(e.message);
			return false;
		});

	}
// ---


//#region -- TAB_MENU --
tabMensajeSeleccionada() {

	this.msgPosicionar = [];
	this.activeItem = this.tabMenuItems[0];

	this.ocultarTabs();
	this.hideMensaje = false;

	if (this.blockUI) {
		this.blockUI.style.display = 'none';
	}

}

tabTipoSeleccionada(): any {
	this.msgPosicionar = [];
	this.activeItem = this.tabMenuItems[1];
	this.msgPosicionar.push({severity: 'info', detail: this.translate.instant('Mensajes.avisoPosicionar')}); // this.translate.instant('MensajesEmergentes.MENSAJE_AVISO_SELECCIONE_NODO')

	this.ocultarTabs();
	this.hideTipo = false;

	if (this.blockUI) {
		this.blockUI.style.display = 'none';
	}
}

tabWebEstadisticasSeleccionada() {
	this.msgPosicionar = [];
	this.activeItem = this.tabMenuItems[2];

	this.ocultarTabs();
	this.hideEstadisticas = false;

	if (this.blockUI) {
		this.blockUI.style.display = 'none';
	}

}

protected ocultarTabs() {
	this.hideMensaje = true;
	this.hideTipo = true;
	this.hideEstadisticas= true;
}

//#endregion


// FORMULARIO
	/* Validar */
	inputChanged(value) {

		const p1Error = this.AvisoSeleccionado.Titulo === '' || this.AvisoSeleccionado.Titulo === undefined;
		const p2Error = this.AvisoSeleccionado.Contenido === '' || this.AvisoSeleccionado.Contenido === undefined;
		const p3Error = this.AvisoSeleccionado.FechaInicio === undefined || this.AvisoSeleccionado.FechaInicio === null || this.AvisoSeleccionado.FechaInicio.toString() === '';
		const p4Error = false;

		let cont = 0;
		if (this.AvisoSeleccionado.alEntrar){
			cont = cont + 1;
		}
		if (this.AvisoSeleccionado.alSalir){
			cont = cont + 1;
		}
		if (this.AvisoSeleccionado.estan){
			cont = cont + 1;
		}
		if (this.AvisoSeleccionado.visitaron){
			cont = cont + 1;
		}
		if (this.AvisoSeleccionado.exploraron){
			cont = cont + 1;
		}
		if (this.AvisoSeleccionado.tienenApp){
			cont = cont + 1;
		}
		const p5Error = cont !== 1;

		// Validacion al guardar
		if (value === 'obligatorio'){
			if (p1Error) {
				this.tituloError = true;
			}
			else {
				this.tituloError = false;
			}

			if (p2Error) {
				this.contenidoError = true;
			}
			else {
				this.contenidoError = false;
			}

			if (p3Error) {
				this.fAltaError = true;
			}
			else {
				this.fAltaError = false;
			}

			if (p4Error) {
				this.fBajaError = true;
			}
			else {
				this.fBajaError = false;
			}

			if (p5Error) {
				this.accionError = true;
			}
			else {
				this.accionError = false;
			}

		}
		// validacion al editar titulo
		else if (value === 'titulo'){
			if (p1Error) {
				this.tituloError = true;
			}
			else {
				this.tituloError = false;
			}
		}
		// validacion al editar contenido
		else if (value === 'contenido'){
			if (p2Error) {
				this.contenidoError = true;
			}
			else {
				this.contenidoError = false;
			}
		}
		else if(value === 'fecha_alta'){
			if (p3Error) {
				this.fAltaError = true;
			}
			else {
				this.fAltaError = false;
			}
		}
		else if(value === 'fecha_baja'){
			if (p4Error) {
				this.fBajaError = true;
			}
			else {
				this.fBajaError = false;
			}
		}
		else if ( value === 'ent' || value === 'sal' || value === 'estan' || value === 'visitaron' || value === 'exploraron' || value === 'tienenApp'){
			if (p5Error) {
				this.accionError = true;
			}
			else {
				this.accionError = false;
			}
		}
	}

	public validar(): boolean {
		this.inputChanged('obligatorio');

		const p1 = this.tituloError;
		const p2 = this.contenidoError;
		const p3 = this.opcionEnvioSeleccionada.index !== 0 && this.opcionEnvioSeleccionada.index !== 4 && this.fAltaError;
		const p4 = this.opcionEnvioSeleccionada.index !== 0 && this.opcionEnvioSeleccionada.index !== 4 && this.fBajaError;
		const p5 = this.opcionEnvioSeleccionada.index !== 0 && this.opcionEnvioSeleccionada.index !== 4 && this.accionError;

		if (p1 || p2 || p3 || p4 || p5) {
			this.isValid = false;
		}
		else {
			this.isValid = true;
		}

		return this.isValid;
	}

	onTabChange(event) {
		console.log('Index: ' + event.index);
		console.log('Index: ' + event.Nombre);

		if (event.index === 0) {
			this.AvisoSeleccionado.estan = true;
			this.AvisoSeleccionado.alEntrar = false;
			this.AvisoSeleccionado.alSalir = false;
			this.AvisoSeleccionado.visitaron = false;
			this.AvisoSeleccionado.exploraron = false;
			this.AvisoSeleccionado.tienenApp = false;
		}
		else{
			this.AvisoSeleccionado.estan = false;
			this.AvisoSeleccionado.alEntrar = false;
			this.AvisoSeleccionado.alSalir = false;
			this.AvisoSeleccionado.visitaron = false;
			this.AvisoSeleccionado.exploraron = false;
			this.AvisoSeleccionado.tienenApp = false;
		}

		// Cuando no esta la pestaña de seleccionar blockUIPlano es undefined
		this.blockUIPlano = document.getElementsByClassName('blockPosicionarNotificacion')[0] as HTMLElement;
		if (this.blockUIPlano) {
			this.blockUIPlano.style.display = 'inherit';
		}

    }

	disableCriterio(CriterioMarcado){

		if ( !(this.AvisoSeleccionado.estan || this.AvisoSeleccionado.alEntrar || this.AvisoSeleccionado.alSalir || this.AvisoSeleccionado.visitaron || this.AvisoSeleccionado.exploraron || this.AvisoSeleccionado.tienenApp)) {
			return false;
		}
		if (CriterioMarcado === 'estan') {
			return (this.AvisoSeleccionado.alEntrar || this.AvisoSeleccionado.alSalir || this.AvisoSeleccionado.visitaron || this.AvisoSeleccionado.exploraron || this.AvisoSeleccionado.tienenApp);
		}
		if (CriterioMarcado === 'ent') {
			return (this.AvisoSeleccionado.estan || this.AvisoSeleccionado.alSalir || this.AvisoSeleccionado.visitaron || this.AvisoSeleccionado.exploraron || this.AvisoSeleccionado.tienenApp);
		}
		if (CriterioMarcado === 'sal') {
			return (this.AvisoSeleccionado.estan || this.AvisoSeleccionado.alEntrar || this.AvisoSeleccionado.visitaron || this.AvisoSeleccionado.exploraron || this.AvisoSeleccionado.tienenApp);
		}
		if (CriterioMarcado === 'visitaron') {
			return (this.AvisoSeleccionado.estan || this.AvisoSeleccionado.alEntrar || this.AvisoSeleccionado.alSalir || this.AvisoSeleccionado.exploraron || this.AvisoSeleccionado.tienenApp);
		}
		if (CriterioMarcado === 'exploraron') {
			return (this.AvisoSeleccionado.estan || this.AvisoSeleccionado.alEntrar || this.AvisoSeleccionado.alSalir || this.AvisoSeleccionado.visitaron || this.AvisoSeleccionado.tienenApp);
		}
		if (CriterioMarcado === 'tienenApp') {
			return (this.AvisoSeleccionado.estan || this.AvisoSeleccionado.alEntrar || this.AvisoSeleccionado.alSalir || this.AvisoSeleccionado.visitaron || this.AvisoSeleccionado.exploraron);
		}
	}

	enviarMensaje(){
		if (this.validar()){
			if (this.opcionEnvioSeleccionada.index === 0 ) {
				this.enviarMensajeInstantaneo();
			}
			else if (this.opcionEnvioSeleccionada.index === 1) {
				this.enviarMensajeProgramado();
			}
			else if (this.opcionEnvioSeleccionada.index === 2) {
				this.enviarMensajeProgramado();
			}
			else if (this.opcionEnvioSeleccionada.index === 3) {
				this.enviarMensajeProgramado();
			}
			else if (this.opcionEnvioSeleccionada.index === 4 ) {
				this.enviarMensajeInstantaneo();
			}
		}
		else {
			this.appComponent.showError(this.translate.instant('MensajesConfirmacion.MENSAJE_FORMULARIO_NO_VALIDO'));
			console.log(this.translate.instant('MensajesConfirmacion.MENSAJE_FORMULARIO_NO_VALIDO'));
		}
	}

	// Envia push inmediatamente el servicio web es el que se encarga de crear el aviso_ciudadano o de editarlo y ademas crea los aviso_ciudadano_envio
	enviarMensajeInstantaneo (){
		const that = this;
		const token = this.authService.getToken();
		const idEspacio = this.espacioSeleccionado.ENTIDAD.Id;
		const idEntidad = this.espacioSeleccionado.ENTIDAD.IdEntidad;
		let idContenido = '';

		if (this.contenidoSeleccionado.length > 0){
			idContenido = this.contenidoSeleccionado[0].IdContenido;
		}

		let salas = [];
		this.criteriosEnvio = [];
		if (this.opcionEnvioSeleccionada.index === 0) {

			this.AvisoSeleccionado.secciones.forEach(seccion => {
				salas.push(seccion.Id);
			});
			this.criteriosEnvio.push(Constantes.ESTAN_AHORA);
		}
		if (this.opcionEnvioSeleccionada.index === 4) {
			if (this.AvisoSeleccionado.estan) {
				this.criteriosEnvio.push(Constantes.ESTAN_AHORA);
			}
			if (this.AvisoSeleccionado.visitaron) {
				this.criteriosEnvio.push(Constantes.VISITADO_ALGUNA_VEZ);
			}
			if (this.AvisoSeleccionado.exploraron) {
				this.criteriosEnvio.push(Constantes.EXPLORADO_ALGUNA_VEZ);
			}
			if (this.AvisoSeleccionado.tienenApp) {
				this.criteriosEnvio.push(Constantes.TIENEN_LA_APP);
			}
		}

		this.sws.wsGetEstimacionDestinatarios(token, idEntidad, idEspacio, [], salas, this.AvisoSeleccionado.Titulo, this.AvisoSeleccionado.Contenido, this.criteriosEnvio).toPromise()
		.then(function(res){
			that.confirmationService.confirm({
				message: that.translate.instant('MensajesConfirmacion.MENSAJE_CONFIRMACION_ENVIO_MENSAJE') + res.lista.length + that.translate.instant('MensajesConfirmacion.MENSAJE_CONFIRMACION_ENVIO_MENSAJE_2'),
				accept: () => {
					// llamar a servicio web envio push
					// SendPush()
					if (that.validar()){
						that.spinner.style.display = 'inherit';

						// Si estamos copiando un aviso mandamos el idAvisoFormulario vacio para que el sw cree el nuevo aviso_ciudadano
						let idAvisoFormulario = null;
						if (that.esCopia || that.esNuevo){
							idAvisoFormulario = null;
						}
						else{
							idAvisoFormulario =  that.AvisoSeleccionado.ENTIDAD.Id;
						}

						that.sws.wsEnviarPush(token, idEntidad, idEspacio, idAvisoFormulario, idContenido, [], salas, that.AvisoSeleccionado.Titulo, that.AvisoSeleccionado.Contenido, that.AvisoSeleccionado.Cuerpo, that.imagenSeleccionada, that.criteriosEnvio).toPromise()
						.then(function(resp){

							if (resp.res === 1){
								if (resp.msg !== '' && resp.msg !== null && resp.msg !== undefined){
									return that.subirFotos(resp.msg);
								}else{
									return 1;
								}
							}
							else {
								console.log('Error wsEnviarPush: ' + resp );
								if (resp.res === -90) {
									that.appComponent.showError(that.translate.instant('Mensajes.nodestinatarios'));
								}
								else{
									that.appComponent.showError(that.translate.instant('Mensajes.mensajeenviadoNOok'));
								}
								that.spinner.style.display = 'none';
								return 0;
							}
						})
						.then(function(resp){
							if (resp !== 0){
								that.AvisoSeleccionado.ENTIDAD.FechaFin = new Date().getTime();
								return that.entityManager.saveChanges();
							}
							else {
								return resp;
							}
						})
						.then(function (resp){
							if (resp !== 0){
								that.appComponent.showSuccess(that.translate.instant('Mensajes.mensajeenviadook'));
								return that.router.navigate(['/mensajes']);
							}
						})
						.then(function(){
							that.spinner.style.display = 'none';
						})
						.catch(function (e) {
							that.spinner.style.display = 'none';
							that.appComponent.showError(e.message);
							return false;
						});
					}
				},
				reject: () => {
					console.log('Cancelado el Envío de Mensaje.');
				}
			});

		})
		.catch(function (e) {
			that.spinner.style.display = 'none';
			that.appComponent.showError(e.message);
			return false;
		});
	}

	enviarMensajeProgramado(){

		if (this.esEdicion){
			this.editarAviso();
		}
		else{
			this.crearNuevoAviso();
		}
	}

	mostrarEnviar(){
		return this.esNuevo || this.esEdicion || this.esCopia;
	}


	// Crea una entrada en AVISO_CIUDADANO (que disparara un envio push en el momento de la localizacion segun algunos criterios)
	crearNuevoAviso(){
		const that = this;
		this.entityManager.newAVISO_CIUDADANO()
		.then(function(AVISO_CIUDADANO){
			// ENTIDAD.Id = that.AvisoSeleccionado.Id;
			AVISO_CIUDADANO.Titulo = that.AvisoSeleccionado.Titulo;
			AVISO_CIUDADANO.Cuerpo = that.AvisoSeleccionado.Cuerpo;
			AVISO_CIUDADANO.FechaCreacion = new Date().getTime();
			AVISO_CIUDADANO.TiempoReenvioMinutos = that.AvisoSeleccionado.repetir ? that.AvisoSeleccionado.TiempoReenvioMinutos : null;
			AVISO_CIUDADANO.Contenido = that.AvisoSeleccionado.Contenido;
			AVISO_CIUDADANO.FechaInicio  = that.AvisoSeleccionado.FechaInicio;
			AVISO_CIUDADANO.FechaFin  = that.AvisoSeleccionado.FechaFin;
			AVISO_CIUDADANO.EsParaVisitantesActuales = that.AvisoSeleccionado.EsParaVisitantesActuales;
			AVISO_CIUDADANO.numeroDestinatarios = that.AvisoSeleccionado.numeroDestinatarios;

			AVISO_CIUDADANO.X  = that.AvisoSeleccionado.X;
			AVISO_CIUDADANO.Y  = that.AvisoSeleccionado.Y;
			AVISO_CIUDADANO.Latitud = that.AvisoSeleccionado.Latitud;
			AVISO_CIUDADANO.Longitud = that.AvisoSeleccionado.Longitud;

			AVISO_CIUDADANO.IdEspacio = that.espacioSeleccionado.Id;
			AVISO_CIUDADANO.ESPACIO = that.espacioSeleccionado.ENTIDAD;

			AVISO_CIUDADANO.Tipo = Constantes.NOTIFICACION_PROGRAMADA;
			AVISO_CIUDADANO.AccionDesencadenante =  that.AvisoSeleccionado.alEntrar ? Constantes.ENVIAR_AL_ENTRAR : ( that.AvisoSeleccionado.alSalir ? Constantes.ENVIAR_AL_SALIR : Constantes.ENVIAR_AL_ENTRAR);    // 0.- Entrando, 1.- Saliendo

			that.AvisoSeleccionado.Id = AVISO_CIUDADANO.Id;
			that.AvisoSeleccionado.FechaCreacion = AVISO_CIUDADANO.FechaCreacion;
			that.AvisoSeleccionado.ENTIDAD = AVISO_CIUDADANO;

			return that.crearRelaciones();
		})
		.then(function () {
			return that.entityManager.saveChanges();
		})
		.then(function () {
			return that.subirFotos(that.AvisoSeleccionado.Id);
		})
		.then(function () {
			that.appComponent.showSuccess(that.translate.instant('Mensajes.mensajeenviadook'));
			that.router.navigate(['/mensajes']);
		})
		.catch(function (e) {
			that.appComponent.showError(e.message);
			return false;
		});
	}

	editarAviso(){
		const that = this;
		// ENTIDAD.Id = that.AvisoSeleccionado.Id;
		that.AvisoSeleccionado.ENTIDAD.Titulo = that.AvisoSeleccionado.Titulo;
		that.AvisoSeleccionado.ENTIDAD.Cuerpo = that.AvisoSeleccionado.Cuerpo;
		that.AvisoSeleccionado.ENTIDAD.FechaCreacion = new Date().getTime();
		that.AvisoSeleccionado.ENTIDAD.TiempoReenvioMinutos = that.AvisoSeleccionado.repetir ? that.AvisoSeleccionado.TiempoReenvioMinutos : null;
		that.AvisoSeleccionado.ENTIDAD.Contenido = that.AvisoSeleccionado.Contenido;
		that.AvisoSeleccionado.ENTIDAD.FechaInicio  = that.AvisoSeleccionado.FechaInicio;
		that.AvisoSeleccionado.ENTIDAD.FechaFin  = that.AvisoSeleccionado.FechaFin;
		that.AvisoSeleccionado.ENTIDAD.EsParaVisitantesActuales = that.AvisoSeleccionado.EsParaVisitantesActuales;
		that.AvisoSeleccionado.ENTIDAD.numeroDestinatarios = that.AvisoSeleccionado.numeroDestinatarios;

		that.AvisoSeleccionado.ENTIDAD.X  = that.AvisoSeleccionado.X;
		that.AvisoSeleccionado.ENTIDAD.Y  = that.AvisoSeleccionado.Y;
		that.AvisoSeleccionado.ENTIDAD.Latitud = that.AvisoSeleccionado.Latitud;
		that.AvisoSeleccionado.ENTIDAD.Longitud = that.AvisoSeleccionado.Longitud;

		that.AvisoSeleccionado.ENTIDAD.IdEspacio = that.espacioSeleccionado.Id;
		that.AvisoSeleccionado.ENTIDAD.ESPACIO = that.espacioSeleccionado.ENTIDAD;

		that.AvisoSeleccionado.ENTIDAD.Tipo = Constantes.NOTIFICACION_PROGRAMADA;
		that.AvisoSeleccionado.ENTIDAD.AccionDesencadenante =  that.AvisoSeleccionado.alEntrar ? Constantes.ENVIAR_AL_ENTRAR : ( that.AvisoSeleccionado.alSalir ? Constantes.ENVIAR_AL_SALIR : Constantes.ENVIAR_AL_ENTRAR);    // 0.- Entrando, 1.- Saliendo

		that.AvisoSeleccionado.ENTIDAD.CONTENID = that.contenidoSeleccionado[0] ? that.contenidoSeleccionado[0].ENTIDAD : that.AvisoSeleccionado.ENTIDAD.CONTENID;
		that.AvisoSeleccionado.ENTIDAD.IdContenido = that.contenidoSeleccionado[0] ? that.contenidoSeleccionado[0].ENTIDAD.Id : that.AvisoSeleccionado.ENTIDAD.IdContenido;

		return that.crearRelaciones()
		.then(function () {
			return that.entityManager.saveChanges();
		})
		.then(function () {
			return that.subirFotos(that.AvisoSeleccionado.Id);
		})
		.then(function () {
			that.appComponent.showSuccess(that.translate.instant('Mensajes.mensajeenviadook'));
			that.router.navigate(['/mensajes']);
		})
		.catch(function (e) {

			that.appComponent.showError(e.message);
			return false;
		});

	}

	crearRelaciones() {
		const that = this;
		const promises: any[] = [];

		// Para la edicion Eliminamos las Relaciones Actuales
		this.eliminarRelaciones();

		// Creamos las Nuevas Relaciones
		/*
		{ index: 4, Nombre: 'Puntual por Espacio'},
		{ index: 0, Nombre: 'Puntual por Sección'},
		{ index: 1, Nombre: 'Programado por Espacio'},
		{ index: 2, Nombre: 'Programado por Sección'},
		{ index: 3, Nombre: 'Programado por Ubicación'}
		*/
		const listaSeleccionados = [];
		if (this.opcionEnvioSeleccionada.index === 1) {
			promises.push(this.entityManager.newESPACIO_has_AVISO());
			listaSeleccionados.push(that.espacioSeleccionado);
		}
		else if (this.opcionEnvioSeleccionada.index === 2) {
			that.AvisoSeleccionado.secciones.forEach(element => {
				promises.push(this.entityManager.newSECCION_has_AVISO());
				listaSeleccionados.push(element);
			});
		}
		else if (this.opcionEnvioSeleccionada.index === 3) {
			promises.push(this.entityManager.newNODO_has_AVISO());
			listaSeleccionados.push(that.AvisoSeleccionado.nodos[0]);
		}
		// resolvemos todos los promises del array
		return allSettled(promises)
		.then(function (datos) {
			if (datos.length === listaSeleccionados.length) {
				for (let index = 0; index < listaSeleccionados.length; index++) {
					const seleccionado = listaSeleccionados[index];
					const element = datos[index].result;

					if (element.constructor.name.indexOf('ESPACIO_has_AVISO') >= 0) {
						element.AVISO_CIUDADANO = that.AvisoSeleccionado.ENTIDAD;
						element.IdAvisoCiudadano = that.AvisoSeleccionado.ENTIDAD.Id;
						element.ESPACIO = seleccionado.ENTIDAD;
						element.IdEspacio = seleccionado.ENTIDAD.Id;

					} else if (element.constructor.name.indexOf('SECCION_has_AVISO') >= 0) {
						element.AVISO_CIUDADANO = that.AvisoSeleccionado.ENTIDAD;
						element.IdAvisoCiudadano = that.AvisoSeleccionado.ENTIDAD.Id;
						element.SECCION = seleccionado.ENTIDAD;
						element.IdSeccion = seleccionado.ENTIDAD.Id;

					} else if (element.constructor.name.indexOf('NODO_has_AVISO') >= 0) {
						element.AVISO_CIUDADANO = that.AvisoSeleccionado.ENTIDAD;
						element.IdAvisoCiudadano = that.AvisoSeleccionado.ENTIDAD.Id;
						element.NODO = seleccionado.ENTIDAD;
						element.IdNodo = seleccionado.ENTIDAD.Id;
					}
				}

				return datos;
			}
			else {
				this.appComponent.showError(that.translate.instant('Contenidos.errorcreandocontenidos'));
				console.log('Error - No se crearon correctamente todas las relaciones de Contenido con las entidades');
			}
		});
	}

	eliminarRelaciones(){
		try {
			this.entityManager.deleteEntityArray(this.AvisoSeleccionado.ENTIDAD.NODOS);
		} catch (error) {
			console.error('ERROR: al borrar relaciones con NODOS: ' + error);
		}

		try {
			this.entityManager.deleteEntityArray(this.AvisoSeleccionado.ENTIDAD.ESPACIOS);
		} catch (error) {
			console.error('ERROR: al borrar relaciones con ESPACIOS: ' + error);
		}

		try {
			this.entityManager.deleteEntityArray(this.AvisoSeleccionado.ENTIDAD.SECCIONES);
		} catch (error) {
			console.error('ERROR: al borrar relaciones con SECCIONES: ' + error);
		}
	}

	cancelar(){
		this.confirmationService.confirm({
            message: this.translate.instant('MensajesConfirmacion.MENSAJE_CONFIRMACION_CANCELAR'),
            accept: () => {
				this.router.navigate(['/mensajes']);
			},
			reject: () => {
				console.log('Cancelado el Cancelado de Contenido.');
			}
        });
	}

	volver(){
		this.router.navigate(['/mensajes']);
	}
// ---


/* TABLA ASIGNACION CONTENIDO */
	onInputSearchChange(){
		const _where = this.filtro.where;
		this.filtro = JSON.parse(FILTRO_INI);
		this.filtro.where = _where;
		this.cargarContenidos();
	}

	filterTipologia(TIPOLOGIA_CONTENIDO){
		const valorFiltrado = TIPOLOGIA_CONTENIDO.Nombre;

		this.filtro.where.Tipologia = valorFiltrado;

		this.cargarContenidos();
	}

	filterEstado(filter) {
		this.filtro.where.estado = filter.value;
		this.cargarContenidos();
	}


	getContenidoEstado(_val) {
		for (const i in this.ContenidoEstado) {
			if (this.ContenidoEstado[i].value === _val) {
				return this.ContenidoEstado[i];
			}
		}
		return {};
	}

	onPageChange(evento) {
		console.log(evento);
		this.filtro.page = evento.page;
		if (this.triggerPageChange){
			this.cargarContenidos();
		}else{
			this.triggerPageChange = true;
		}
	}

	onSort(evento) {
		console.log(evento);

		let field = evento.field;
		if (field === 'expirado') {
			field = 'Estado';
			// 	field = 'FechaBaja';

		}

		const sentido = evento.order > 0 ? 'ASC' : 'DESC';

		const actual = field + ' ' + sentido;
		if (actual !== this.filtro.order) {
			this.filtro.order = actual;
			this.cargarContenidos();
		}
	}

	asignarContenido(rowData) {

		// Asignamos contenidos
		const idContenido = rowData.ENTIDAD.Id ? rowData.ENTIDAD.Id : rowData.Id;

		this.contenidosTodos = this.contenidosTodos.filter(obj => obj.ENTIDAD.Id !== idContenido);
		this.contenidoSeleccionado = new Array();
		this.contenidoSeleccionado.push(rowData);

		let filtroNoAsignados;;


		if (this.dt_no_asignados.filters) {
			filtroNoAsignados = this.dt_no_asignados.filters;
		}

		if (filtroNoAsignados !== undefined){
			this.dt_no_asignados.reset();
			this.dt_no_asignados.filters = filtroNoAsignados;
			this.dt_no_asignados.filter();
		}else{
			this.dt_no_asignados.reset();
		}


		this.filtro.total = this.contenidosTodos.length;

		if (this.contenidosTodos.length === 0 && this.filtro.page > 0)
		{
			this.filtro.page--;

			this.pg_no_asignados.paginatorState.page = this.filtro.page;
			this.pg_no_asignados.paginatorState.totalRecords = this.filtro.total;

			this.pg_no_asignados.changePage(this.filtro.page);
		}

		this.displayDialog = false;
	}

	desasignarContenido(rowData) {
		this.contenidosTodos.push(rowData);
		this.contenidoSeleccionado = new Array();


			// ASIGNADOS
			let value = '';
			let matchMode = '';
			if (this.dt_no_asignados.filters && this.dt_no_asignados.filters.global) {
				value = this.dt_no_asignados.filters.global.value;
				matchMode = this.dt_no_asignados.filters.global.matchMode;
			}

			this.dt_no_asignados.reset();

			// if (this.dt_no_asignados.filters && this.dt_no_asignados.filters.global) {
			this.dt_no_asignados.filterGlobal(value, matchMode);
			// }

			// NO ASIGNADOS
			value = '';
			matchMode = '';
			// }
	}

	mostrarEditar(rowdata) {
		rowdata.MostrarEdicion = true;
	}

	ocultarEditar(rowdata) {
		rowdata.MostrarEdicion = false;
	}

	mostrarAsignarContenido(){
		this.cargarContenidos();
		this.displayDialog = true;
	}

	cargarContenidos() {
		const that = this;
		// Mostramos Spinner
		this.spinner.style.display = 'inherit';

		const columnas = [];
		const token = this.authService.getToken();

		const idIdioma = this.idiomaSeleccionado.ENTIDAD.Id;
		const idEspacio = this.espacioSeleccionado.Id;
		const _elementoAsignado = this.filtro.where['ElementoAsignado'];
		const _titulo = this.filtro.where['Titulo'];
		const _idAlternativo =  this.filtro.where['IdAlternativo'];

		let _tipologia = '';
		if (this.filtro.where.Tipologia && this.translate.instant('Contenidos.estadoTodos') !== this.filtro.where.Tipologia.toString()) {
			_tipologia =  this.filtro.where['Tipologia'];
		}
		let size = 10;
		let first = this.filtro.page * size;

		const orderBy = this.filtro.order.split(' ')[0];
		const order = this.filtro.order.split(' ')[1];

		const _estado =  this.filtro.where.estado;
		const Desde =  this.filtro.Desde;
		const Hasta =  this.filtro.Hasta;

		let ids = [];

		let excluidos = new Array();
		that.contenidosTodos = new Array();


		let Activos = false;
		if (that.permisos.Gestion_Activos === 2) {
			Activos = true;
		}


		// this.entityManager.getCONTENIDOOrdenado(where, order, top, page, includes, columnas )
		this.sws.wsBuscarContenidos(token, idEspacio, idIdioma, _titulo, _estado, Desde, Hasta, _idAlternativo, _tipologia, _elementoAsignado, first, size, orderBy, order, excluidos, Activos).toPromise()
		.then(function(resp){
			ids = resp.lista;

			that.filtro.total = resp.total;
			let includes = 'FOTOS, ';
			includes = includes + 'IDIOMAS, ';
			includes = includes + 'ALAS.ALA.IDIOMAS, ';
			includes = includes + 'ESPACIOS.ESPACIO.IDIOMAS, ';
			includes = includes + 'SECCIONES.SECCION.IDIOMAS, ';
			includes = includes + 'NODODS.NODO.SECCION, ';
			includes = includes + 'TIPOLOGIA_CONTENIDO.IDIOMAS';

			return that.entityManager.getContenidosById(ids, includes, columnas);
		})
		.then(function (data) {
			that.contenidosTodos = [];
			that.contenidosFiltrados = [];

			// Ordenamos los contenidos segun el orsen en el que obtubimos los id ya que el breeze no nos devuelve los contenidos en el orden de los Ids
			data = data.sort(function(a, b){
				return ids.indexOf(a.Id) - ids.indexOf(b.Id);
			});

			data.forEach(cont => {
				try {
					const contenido = new Contenido().fromENTIDAD(cont);
					if (contenido.Imagen === null || contenido.Imagen === undefined || contenido.Imagen === ''){
						contenido.Imagen = that.authService.getFotoPorDefecto();
					}
					that.contenidosFiltrados.push(contenido);
				}
				catch (ex) {
					that.appComponent.showError(that.translate.instant('MensajesEmergentes.MENSAJE_ERROR_CONTENIDOS_CARGAR'));
				}
			});

			that.contenidosFiltrados.forEach(elemento => {
				if (elemento.Imagen === undefined) {
					elemento.Imagen = that.authService.getFotoBlobPorDefecto();
				}
			});

			const conts = that.contenidosFiltrados.find( c => c.Id === that.AvisoSeleccionado.ENTIDAD.IdContenido);
			if(conts){
				that.contenidoSeleccionado = [conts];
				that.contenidosFiltrados.filter( c => c.Id !== that.AvisoSeleccionado.ENTIDAD.IdContenido);
			}

			that.contenidosFiltrados.forEach((contenidoFormulario: Contenido) => {
				const contenido = new Contenido().fromENTIDAD(contenidoFormulario.ENTIDAD);
				that.contenidosTodos.push(contenido);
			});

			that.dt_no_asignados.reset();

			// Traducimos Contenidos al idioma seleccionado
			that.contenidosFiltrados = that.idiomaService.traducirContenidos(that.contenidosFiltrados, that.idiomaSeleccionado);
			that.triggerPageChange = false;

			that.pg_no_asignados.paginatorState.page = that.filtro.page;
			that.pg_no_asignados.paginatorState.totalRecords = that.filtro.total;

			that.pg_no_asignados.changePage(that.filtro.page);

			that.spinner.style.display = 'none';
		});
	}

// ------

// FOTO
	/* imagen */
 	onFileSelect($event) {
	 	this.msgFoto = [];
	 	this.imagenSeleccionada = $event.files[0];
	}

	onRemoveSelect(){
	 	this.imagenSeleccionada = undefined;
	}

	eliminarUploadedFiles() {
	 	this.onRemoveSelect();
	}

	public subirFotos(idMensaje){
	 	// PREPARAMOS LA SUBIDA DE LAS FOTOS
	 	const promises: any[] = [];
	 	const that = this;

	 	if (that.imagenSeleccionada !== undefined && idMensaje !== undefined && idMensaje !== null && idMensaje !== '') {
			 promises.push(that.enviarFoto('IdAvisoCiudadano', idMensaje, that.imagenSeleccionada));
		}

	 	return allSettled(promises);
	}

	public onTextChange($event): void {
		this.AvisoSeleccionado.Cuerpo = $event.htmlValue;
		console.log(this.AvisoSeleccionado.Cuerpo);
	}

	enviarFoto(entidad, idEntidad, imagen, idFoto = null) {
		const token = this.authService.getToken();
		if (imagen !== undefined) {
			return this.sws.wsSubidaFoto(token, entidad, idEntidad, imagen, imagen.name, idFoto).toPromise();
		}
	}

	/* Image Cropper */
	fileChangeListener($event) {
	 	this.imageCropperVisible = true;
	 	const image: any = new Image();
	 	const file: File = $event.target.files[0];
	 	const nombre = file.name;
	 	const tipo = file.type;
	 	const myReader: FileReader = new FileReader();
	 	const that = this;
	 	myReader.onloadend = function (loadEvent: any) {
	 		image.src = loadEvent.target.result;
	 		that.cropper.setImage(image);
	 		that.sws.base64ToFile(image.src, nombre, tipo)
	 		.then(function(fotoFile){
	 			that.imagenSeleccionada = fotoFile;
	 		});
	 	};
	 	myReader.readAsDataURL(file);
	}

	asignarFotoCropp(){
	 	const that = this;
	 	this.sws.base64ToFile(this.data.image, that.imagenSeleccionada.name)
	 	.then(function(fotoFile){
	 		that.imagenSeleccionada = fotoFile;
 		that.imageCropperVisible = false;
	 	});
	}
// ------


//#region  -- PLANO --

bloquearMapa(){
	this.msgPosicionar = [];
	this.blockUIPlano = document.getElementsByClassName('blockPosicionarNotificacion')[0] as HTMLElement;
	this.blockUIPlano.style.display = 'inherit';
	this.msgPosicionar.push({severity: 'info', detail: this.translate.instant('Contenidos.avisoDesbloquear')}); // this.translate.instant('MensajesEmergentes.MENSAJE_AVISO_SELECCIONE_NODO')
}

desBloquearMapa(){
	this.msgPosicionar = [];
	this.blockUIPlano = document.getElementsByClassName('blockPosicionarNotificacion')[0] as HTMLElement;
	this.blockUIPlano.style.display = 'none';
	this.msgPosicionar.push({severity: 'info', detail: this.translate.instant('Contenidos.avisoPosicionar')}); // this.translate.instant('MensajesEmergentes.MENSAJE_AVISO_SELECCIONE_NODO')
}

mapaBloqueadoClick(){
	this.appComponent.showWarn('mensaje', this.translate.instant('MensajesConfirmacion.MAPA_BLOQUEADO'));
}

	mostrarSeleccionarAla(ala) {
		ala.seleccionarVisible = true;
	}

	ocultarSeleccionarAla(ala) {
		ala.seleccionarVisible = false;
	}

	seleccionarAla(ala: AlaFormulario) {
		this.seleccionarAlaPresionado(ala);
	}

	seleccionarAlaPresionado(ala: AlaFormulario) {
		this.alaSeleccionada = ala;
		this.pathPlano = this.alaSeleccionada.RutaImagen;
	}

	/* PLANO */
	public onSVGLoaded() {
		this.zoomLevels = [Constantes.ZOOM_MINIMO, Constantes.ZOOM_MAXIMO];

		let avisoPlano: NotificacionPlano;

		if (this.esEdicion ){
			if (!this.AvisoSeleccionado.ENTIDAD.X) { this.AvisoSeleccionado.ENTIDAD.X = Constantes.X_COORDENADA; }
			if (!this.AvisoSeleccionado.ENTIDAD.Y) { this.AvisoSeleccionado.ENTIDAD.Y = Constantes.Y_COORDENADA; }
			avisoPlano = new NotificacionPlano(this.AvisoSeleccionado.ENTIDAD.Id, this.AvisoSeleccionado.ENTIDAD.Nombre, this.AvisoSeleccionado.ENTIDAD.X, this.AvisoSeleccionado.ENTIDAD.Y, '', null, this.alaSeleccionada.IconoContenidoScale);
		}
		else{
			if (!this.AvisoSeleccionado.X) { this.AvisoSeleccionado.X = Constantes.X_COORDENADA; }
			if (!this.AvisoSeleccionado.Y) { this.AvisoSeleccionado.Y = Constantes.Y_COORDENADA; }
			avisoPlano = new NotificacionPlano('IdProbisional', this.AvisoSeleccionado.Titulo, this.AvisoSeleccionado.X, this.AvisoSeleccionado.Y, '', null, this.alaSeleccionada.IconoContenidoScale);
		}

		avisoPlano.setSimbolo('assets/itsoft/IconosSVG/email.svg');
		avisoPlano.symbolStroke = Constantes.contenidoSymbolStroke;
		avisoPlano.symbolFill = Constantes.contenidoSymbolFill;
		avisoPlano.symbolStrokeWidth = Constantes.contenidoSymbolStrokeWidth;
		avisoPlano.symbolSize = Constantes.contenidoSymbolSize;

		avisoPlano.sectionHoverFill = Constantes.contenidoSectionHoverFill;
		avisoPlano.sectionHoverStroke = Constantes.contenidoSectionHoverStroke;
		avisoPlano.setIconHeight(Constantes.contenidoIconHeight);
		avisoPlano.setIconWidth(Constantes.contenidoIconWidth);

		avisoPlano.setIconAlign('center-center');

		this.avisosPlano = [avisoPlano];

		this.pintarSecciones();
	}

	public onSVGClicked() {
		this.appComponent.showWarn('mensaje', this.translate.instant('MensajesConfirmacion.NO_SECCION_CLICK'));
	}

	public onSeccionClicked($event){
		if (this.mostrarEnviar()) {
			// Asignamos el aviso al nodo mas cercano al click realizado
			const asignado = this.asignarNodoMasCescano($event.id, $event.mp[0], $event.mp[1]);
			if ( asignado ){
				console.log('onSeccionClicked');
				this.posicionarAviso($event);
			}
			else{
				this.appComponent.showWarn('mensaje', this.translate.instant('MensajesConfirmacion.NO_NODO_CERCA'));
			}
		}
	}

	onNotificationClicked($event){
		if (!this.mostrarEnviar()) {
			this.router.navigate(['/mapas/editar', { id: this.alaSeleccionada.Id }]);
		}
	}

	public asignarNodoMasCescano(idSeccion, x, y){
		console.log('---------------------------------');
		let seccion;
		let nodos = [];

		if (idSeccion === '') {
			seccion = this.seccionDefecto;
			nodos = seccion.NODOS;
		}
		else{
			seccion = this.mapSectionsPlano.get(idSeccion);
			nodos = seccion.ENTIDAD.NODOS;
		}

		// d = sqrt( (x2 - x1)^2 + (y2 - y1)^2 )
		let distanciaMinima = Constantes.MAX_PESO;
		let nodoMasCercano;
		nodos.forEach(nodo => {
			const x1 = nodo.X;
			const y1 = nodo.Y;
			const x2 = x;
			const y2 = y;

			const d = Math.sqrt( Math.pow((x2 - x1), 2) + Math.pow((y2 - y1), 2) );
			console.log('--- Distancia a: ' + nodo.Nombre + ' = ' + d);

			// Utilizamos valores negativos para no tener que utilizar MaxValue para la inicializacion de distanciaMinima
			if (d < distanciaMinima) {
				distanciaMinima = d;
				nodoMasCercano = nodo;
			}
		});

		if (!nodoMasCercano) {
			return false;
		}
		const idNodoMasCercano = nodoMasCercano.Id;

		const nodoFormularioMasCercano = this.listaEntidades.filter(obj => obj.Id === idNodoMasCercano)[0];

		// Ya estaba asignado a ese nodo
		if (!nodoFormularioMasCercano) {
			console.log('---  No NODO mas cercza');
			return true;
		}
		else{
			this.nodoSeleccionado = nodoFormularioMasCercano;

			this.AvisoSeleccionado.nodos = [this.nodoSeleccionado];
			this.AvisoSeleccionado.X = this.nodoSeleccionado.X;
			this.AvisoSeleccionado.Y = this.nodoSeleccionado.Y;
			this.AvisoSeleccionado.Latitud = this.nodoSeleccionado.Latitud;
			this.AvisoSeleccionado.Longitud = this.nodoSeleccionado.Longitud;

			console.log('--- NODO mas cerca: ' + nodoMasCercano.Nombre);
			console.log('---------------------------------');
			return true;
		}
	}

	posicionarAviso(event){
		if (this.esEdicion ){
			this.AvisoSeleccionado.ENTIDAD.X = event.mp[0]; // + this.offset_x_icono_contenido;
			this.AvisoSeleccionado.ENTIDAD.Y = event.mp[1]; //  + this.offset_y_icono_contenido;

			this.avisosPlano[0].setX(this.AvisoSeleccionado.ENTIDAD.X);
			this.avisosPlano[0].setY(this.AvisoSeleccionado.ENTIDAD.Y);
		}
		else{
			this.AvisoSeleccionado.X = event.mp[0]; //  + this.offset_x_icono_contenido;
			this.AvisoSeleccionado.Y = event.mp[1]; //  + this.offset_y_icono_contenido;

			this.avisosPlano[0].setX(this.AvisoSeleccionado.X);
			this.avisosPlano[0].setY(this.AvisoSeleccionado.Y);
		}

		this.avisosPlano[0].setSimbolo('assets/itsoft/IconosSVG/email.svg');
		this.avisosPlano[0].symbolStroke = Constantes.contenidoSymbolStroke;
		this.avisosPlano[0].symbolFill = Constantes.contenidoSymbolFill;
		this.avisosPlano[0].symbolStrokeWidth = Constantes.contenidoSymbolStrokeWidth;
		this.avisosPlano[0].symbolSize = Constantes.contenidoSymbolSize;

		this.avisosPlano[0].sectionHoverFill = Constantes.contenidoSectionHoverFill;
		this.avisosPlano[0].sectionHoverStroke = Constantes.contenidoSectionHoverStroke;
		this.avisosPlano[0].setIconHeight(Constantes.contenidoIconHeight);
		this.avisosPlano[0].setIconWidth(Constantes.contenidoIconWidth);
		this.avisosPlano[0].setIconAlign('center-center');

		this.avisosPlano = [this.avisosPlano[0]];
	}

	pintarSecciones(){
		const secciones = new Array<SeccionPlano>();
		this.mapSectionsPlano = new Map<String, SeccionPlano>();

		this.alaSeleccionada.ENTIDAD.SECCIONS.forEach(seccion => {
			if (!this.seccionDefecto || !seccion.CoordenadasPoligono) {
				this.seccionDefecto = seccion;
			}

			const seccionCoordenadasPoligono: Array<Array<number>> = (!seccion.CoordenadasPoligono ? null : JSON.parse(seccion.CoordenadasPoligono));

			const seccionPlano = new SeccionPlano(seccion.Id, seccion.Nombre, seccionCoordenadasPoligono, seccion.ALA.PuntosSeccionScale , seccion.ALA.AristaSeccionScale);
			seccionPlano.ENTIDAD = seccion;
			seccionPlano.fill  = seccion.Color;
			seccionPlano.stroke = seccion.Color;
			seccionPlano.strokeWidth = Constantes.seccionStrokeWidth;
			seccionPlano.hoverFill = seccion.Color;
			seccionPlano.hoverStroke = seccion.Color;
			secciones.push(seccionPlano);
			this.mapSectionsPlano.set(seccion.Id, seccionPlano);

		});

		this.sectionsPlano = secciones;
		console.log('sections... ' + this.sectionsPlano.length);

		// Cuando no esta la pestaña de seleccionar blockUIPlano es undefined
		this.blockUIPlano = document.getElementsByClassName('blockPosicionarNotificacion')[0] as HTMLElement;
		if (this.blockUIPlano && this.blockUIPlano.style.display === '') {
			this.blockUIPlano.style.display = 'inherit';
		}

	}

	public alaSeleccionadaChange($event){
		this.alaSeleccionada = $event.value;
		this.seleccionarAla(this.alaSeleccionada);
	}

//#endregion


// Alertas Emergentes
protected showError = (mensaje) => {
	this.msgs = [];
	this.msgs.push({severity: 'error',  detail: mensaje});
}

protected showSuccess = (mensaje) => {
	this.msgs = [];
	this.msgs.push({severity: 'success',  detail: mensaje});
}
// ---


onFechaAceptar(dt, calendar, columna, tipo) {
	console.log(calendar);
	const fecha = calendar.value ? calendar.value : new Date();
	if (columna === 'fecha_alta') {
		this.AvisoSeleccionado.FechaInicio = fecha;
	}
	if (columna === 'fecha_baja') {
		this.AvisoSeleccionado.FechaFin = fecha;
	}

	this.inputChanged(columna);
	calendar.overlayVisible=false;
}


}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/views/Mensajes/nuevo/nuevo.mensaje.component.ts